import { render } from "./SaveBtn.vue?vue&type=template&id=19e0cb72"
const script = {}
script.render = render

export default script